var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('global-snackbar'),_c('confirm-dialog'),_c('high-cloudy-image-confirm-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }